export function isVenngoRedemptionOptions(options) {
    return options.tagline !== undefined;
}
export function isADRedemptionOptions(options) {
    return options.display !== undefined;
}
export var ADRedemptionType;
(function (ADRedemptionType) {
    ADRedemptionType["InStore"] = "instore";
    ADRedemptionType["Online"] = "online";
    ADRedemptionType["Mobile"] = "mobile";
})(ADRedemptionType || (ADRedemptionType = {}));
export var VenngoRedemptionType;
(function (VenngoRedemptionType) {
    VenngoRedemptionType[VenngoRedemptionType["Email"] = 1] = "Email";
    VenngoRedemptionType[VenngoRedemptionType["InStore"] = 2] = "InStore";
    VenngoRedemptionType[VenngoRedemptionType["Mobile"] = 3] = "Mobile";
    VenngoRedemptionType[VenngoRedemptionType["Online"] = 4] = "Online";
})(VenngoRedemptionType || (VenngoRedemptionType = {}));
export var RedemptionType;
(function (RedemptionType) {
    RedemptionType["Online"] = "link";
    RedemptionType["Phone"] = "call";
    RedemptionType["Email"] = "email";
    RedemptionType["InStore"] = "instore";
})(RedemptionType || (RedemptionType = {}));
export var RedemptionTypeName;
(function (RedemptionTypeName) {
    RedemptionTypeName[RedemptionTypeName["email"] = 1] = "email";
    RedemptionTypeName[RedemptionTypeName["instore"] = 2] = "instore";
    RedemptionTypeName[RedemptionTypeName["mobile"] = 3] = "mobile";
    RedemptionTypeName[RedemptionTypeName["online"] = 4] = "online";
})(RedemptionTypeName || (RedemptionTypeName = {}));
